import OntripOrdersDetails from './details';
import OntripOrdersInsights from './insights';

export {
  OntripOrdersDetails,
  OntripOrdersInsights,
};

export default OntripOrdersInsights;
